<template>
  <div class="flex gap-2">
    <input
      :id="id"
      v-model="selected"
      :value="value"
      class="checkbox-input border-gray-500 size-5 items-center border text-black focus:ring-2"
      :class="{ 'group-hover:bg-gray-200': !selected }"
      type="checkbox"
      @change="$emit('change')"
    />
    <label
      :for="id"
      class="group flex cursor-pointer space-x-2 text-sm"
      :class="{ 'font-bold': selected, 'items-center': centered }"
    >
      <span>
        <slot name="label">{{ label }}</slot>
      </span>
    </label>
  </div>
</template>

<script lang="ts">
export default defineComponent({
  name: 'Checkbox',
  props: {
    value: {
      type: [String, Number] as PropType<string | number>,
      default: () => '',
    },
    centered: {
      type: Boolean as PropType<boolean>,
      default: () => true,
    },
    checked: {
      type: Boolean as PropType<boolean>,
      default: () => {},
    },
    id: {
      type: String as PropType<string | undefined>,
      required: true,
    },
    label: {
      type: String as PropType<string>,
      default: undefined,
      required: false,
    },
  },
  emits: ['change', 'input'],

  setup(props, { emit }) {
    const selected = computed({
      get() {
        return props.checked
      },
      set(newValue): void {
        emit('input', newValue)
      },
    })

    return { selected }
  },
})
</script>

<style scoped>
/* This is a exception because the checkbox is taking in the line height of the text */
.checkbox-input {
  min-height: auto !important;
  padding: 0 !important;
  line-height: 1 !important;
}
</style>
